var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper",style:(_vm.wrapperStyle)},[_c('div',{staticClass:"loading-wrapper-inner"},[_c('double-bounce-spinner',{attrs:{"loading":_vm.loading,"color":_vm.color}}),(_vm.branding)?_c('span',{staticClass:"loading-branding"},[_vm._v("KMS")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }